<template>
  <flat-pickr
    class="date-input form-control"
    v-bind="$attrs"
    :config="mergedConfig"
    :value="value"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @blur="$emit('blur', $event)"
  />
</template>

<script>
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Portuguese } from 'flatpickr/dist/l10n/pt';
import { Spanish } from 'flatpickr/dist/l10n/es';

export default {
  name: 'DatePickerRangeAdapter',
  components: { FlatPickr },
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Date, Number],
      default: null,
    },
    minDate: {
      type: [String, Date, Number],
      default: null,
    },
    maxDate: {
      type: [String, Date, Number],
      default: null,
    },
  },
  computed: {
    currentLanguage() {
      return this.$i18n?.locale;
    },
    getLanguage() {
      switch (this.currentLanguage) {
        case 'en':
          return null;
        case 'es':
          return Spanish;
        default:
          return Portuguese;
      }
    },
    mergedConfig() {
      return {
        dateFormat: 'Y-m-d',
        altFormat: 'd/m/Y',
        time_24hr: true,
        altInput: true,
        defaultHour: 0,
        defaultMinute: 0,
        locale: this.getLanguage,
        allowInput: true,
        allowInvalidPreload: true,
        minDate: this.minDate || null,
        maxDate: this.maxDate || null,
      };
    },
  },
};
</script>

<style lang="stylus">
.date-input
  &.form-control:disabled, &.form-control[readonly]
    background-color: #fff
</style>
